import Link from '@/gf/components/Link'
import { BuildingOfficeIcon } from '@heroicons/react/24/outline'
import { PlusIcon } from '@heroicons/react/20/solid'
import IconZeroState from '../../components/IconZeroState'

const ActivityZeroState = () => (
  <IconZeroState
    title="No vendor activity so far"
    subtitle="Get started by requesting a quote for parts."
    icon={BuildingOfficeIcon}
  >
    <Link.P
      to={`/rfqs/create?source.path=${encodeURIComponent(
        document.location.pathname
      )}&source.button=create-request`}
    >
      <PlusIcon className="inline-block h-4" /> Create Request
    </Link.P>
  </IconZeroState>
)

export default ActivityZeroState
